import { Listing } from '@smg-real-estate/hg-rets-schema';

const MULTIPLE_SPACES_REGEX = /\s{2,}/g;

export const formatListingAddress = (listing: Listing): string | undefined => {
  if (!listing) {
    return '';
  }

  const { address } = listing;
  const street = address?.street || '';
  const postalCode = address?.postalCode || '';
  const locality = address?.locality || '';

  return `${street}${street && (postalCode || locality) ? ', ' : ''}${postalCode} ${locality}`
    .replaceAll(MULTIPLE_SPACES_REGEX, ' ')
    .trim();
};

export const formatListingAddressWithoutStreet = (listing: Listing): string | undefined => {
  if (!listing) {
    return '';
  }

  const { address } = listing;
  const postalCode = address?.postalCode || '';
  const locality = address?.locality || '';

  return `${postalCode} ${locality}`.replaceAll(MULTIPLE_SPACES_REGEX, ' ').trim();
};
